function request(reflexId, target, args, controller, element, controllerElement) {
  reflexes[reflexId].timestamp = new Date();
  console.log("\u2191 stimulus \u2191 ".concat(target), {
    reflexId: reflexId,
    args: args,
    controller: controller,
    element: element,
    controllerElement: controllerElement
  });
}
function success(event) {
  var _ref = event || {},
    detail = _ref.detail;
  var _ref2 = detail || {},
    selector = _ref2.selector;
  var _ref3 = detail.stimulusReflex || {},
    reflexId = _ref3.reflexId,
    target = _ref3.target,
    morph = _ref3.morph,
    serverMessage = _ref3.serverMessage;
  var reflex = reflexes[reflexId];
  var progress = reflex.totalOperations > 1 ? " ".concat(reflex.completedOperations, "/").concat(reflex.totalOperations) : '';
  var duration = reflex.timestamp ? "in ".concat(new Date() - reflex.timestamp, "ms") : 'CLONED';
  var operation = event.type.split(':')[1].split('-').slice(1).join('_');
  var halted = serverMessage && serverMessage.subject === 'halted' || false;
  console.log("\u2193 reflex \u2193 ".concat(target, " \u2192 ").concat(selector || "\u221E").concat(progress, " ").concat(duration), {
    reflexId: reflexId,
    morph: morph,
    operation: operation,
    halted: halted
  });
}
function error(event) {
  var _ref4 = event || {},
    detail = _ref4.detail;
  var _ref5 = detail.stimulusReflex || {},
    reflexId = _ref5.reflexId,
    target = _ref5.target,
    serverMessage = _ref5.serverMessage;
  var reflex = reflexes[reflexId];
  var duration = reflex.timestamp ? "in ".concat(new Date() - reflex.timestamp, "ms") : 'CLONED';
  var payload = detail.stimulusReflex;
  console.log("\u2193 reflex \u2193 ".concat(target, " ").concat(duration, " %cERROR: ").concat(serverMessage.body), 'color: #f00;', {
    reflexId: reflexId,
    payload: payload
  });
}
export default {
  request: request,
  success: success,
  error: error
};